import { render } from "./Protocol.vue?vue&type=template&id=fa91110e&scoped=true"
import script from "./Protocol.vue?vue&type=script&lang=js"
export * from "./Protocol.vue?vue&type=script&lang=js"

import "./Protocol.vue?vue&type=style&index=0&id=fa91110e&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa91110e"]])

export default __exports__